import { Pressable, StyleSheet, Text, type PressableStateCallbackType } from 'react-native';

import { colorSemantic, rippleOnSurface, spacing } from '@/theme';

const RIPPLE_CONFIG = { color: rippleOnSurface };

export interface TextLinkProps {
  readonly label: string;
  readonly onPress: () => void;
  readonly color?: string;
  readonly disabled?: boolean;
  readonly flush?: boolean;
  readonly testID?: string;
}

export const TextLink = ({
  label,
  onPress,
  color,
  disabled = false,
  flush = false,
  testID,
}: TextLinkProps) => {
  const getPressableStyle = ({ pressed }: PressableStateCallbackType) => [
    styles.pressable,
    flush ? styles.flush : null,
    pressed || disabled ? styles.pressed : null,
  ];

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityState={{ disabled }}
      android_ripple={RIPPLE_CONFIG}
      disabled={disabled}
      onPress={onPress}
      style={getPressableStyle}
      testID={testID}>
      <Text style={[styles.label, color ? { color } : null]}>{label}</Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  pressable: {
    justifyContent: 'center',
    minHeight: 48,
    paddingHorizontal: spacing[4],
    paddingVertical: 10,
  },
  flush: {
    minHeight: 40,
    paddingLeft: 0,
    paddingRight: spacing[4],
  },
  pressed: {
    opacity: 0.6,
  },
  label: {
    color: colorSemantic.colorTextInfoStrong,
    fontSize: 14,
    fontWeight: '500',
    letterSpacing: 0.1,
    lineHeight: 20,
  },
});
